import React from "react";
 
import team1 from "../../assets/images/jpgs/team1.jpg";
import team2 from "../../assets/images/jpgs/team2.jpg";
import team3 from "../../assets/images/jpgs/team3.jpg";
import team4 from "../../assets/images/jpgs/team4.jpg";
import team5 from "../../assets/images/jpgs/team5.jpg";
import team6 from "../../assets/images/jpgs/team6.jpg";
import team7 from "../../assets/images/jpgs/team7.jpg";
import team9 from "../../assets/images/jpgs/team9.jpg";
import team10 from "../../assets/images/jpgs/team10.jpg";
import team11 from "../../assets/images/pngs/team11.png";
import team12 from "../../assets/images/pngs/team12.png";
import team13 from "../../assets/images/pngs/team13.png";
import team14 from "../../assets/images/pngs/team14.png";
import team15 from "../../assets/images/pngs/team15.png";
import team16 from "../../assets/images/pngs/team16.png";
import team17 from "../../assets/images/pngs/team17.png";
import team18 from "../../assets/images/pngs/team18.png";
 
import { FaLinkedinIn } from "react-icons/fa";
 
const Team = () => {
  const teamData = [
    {
      id: 1,
      img: team1,
      name: "Pradnesh Patil",
      designation: "Co-founder & CEO",
      linkedin: "https://www.linkedin.com/in/pradneshpatil/",
    },
    {
      id: 2,
      img: team2,
      name: "Anand Gupta",
      designation: "Co-founder & CTO",
      linkedin: "https://www.linkedin.com/in/anandguptas/",
    },
    {
      id: 3,
      img: team9,
      name: "Michiel De Smet",
      designation: "Founding Engineer",
      linkedin: "https://www.linkedin.com/in/michieldesmet/",
    },
    {
      id: 4,
      img: team15,
      name: "Andrew Huynh",
      designation: "Founding Solutions Architect",
      linkedin: "https://www.linkedin.com/in/andrewdoesdata/",
    },
    {
      id: 5,
      img: team10,
      name: "John Ryan",
      designation: "Consultant",
      linkedin: "https://www.linkedin.com/in/johnryanuk/",
    },
    {
      id: 6,
      img: team16,
      name: "Dipayan Bhowmick",
      designation: "Director of engineering",
      linkedin: "https://www.linkedin.com/in/dipayan-bhowmick",
    },
    {
      id: 7,
      img: team17,
      name: "David Abraham",
      designation: "Enterprise Sales",
      linkedin: "https://www.linkedin.com/in/davidabrahamiii/",
    },
    {
      id: 8,
      img: team13,
      name: "Dana Van Aken",
      designation: "Lead Research Scientist",
      linkedin: "https://www.linkedin.com/in/danavanaken/",
    },
    {
      id: 9,
      img: team12,
      name: "Rakend Dubba",
      designation: "Senior ML Engineer",
      linkedin: "https://www.linkedin.com/in/rakendd/",
    },
    {
      id: 10,
      img: team11,
      name: "Saravanan Shanmugam",
      designation: "Senior Software Engineer",
      linkedin: "https://www.linkedin.com/in/saravmajestic/",
    },
    {
      id: 11,
      img: team14,
      name: "Ravikumar Thangaraj",
      designation: "Data Engineer",
      linkedin: "https://in.linkedin.com/in/ravikumarthangaraj",
    },
    {
      id: 12,
      img: team3,
      name: "Surya Iyer",
      designation: "Founding Software Engineer",
      linkedin: "https://www.linkedin.com/in/suryaiyer/",
    },
    {
      id: 13,
      img: team18,
      name: "Dingkang Wang",
      designation: "Research Engineer",
      linkedin: "https://www.linkedin.com/in/dingkang-wang-661219a0/",
    },
    {
      id: 14,
      img: team5,
      name: "Pulkit Gaur",
      designation: "Founding Software Engineer",
      linkedin: "https://www.linkedin.com/in/gaurpulkit/",
    },
    {
      id: 15,
      img: team7,
      name: "Md Sakib",
      designation: "Founding Product Designer",
      linkedin: "https://www.linkedin.com/in/sakibiz/",
    },
    {
      id: 16,
      img: team4,
      name: "Aditya Gajbhiye",
      designation: "Founding Software Engineer",
      linkedin: "https://www.linkedin.com/in/aditya-gajbhiye-7b5b2a151/",
    },
  ];
  return (
    <div className="team md:py-[100px] py-[50px]">
      <div className="custom-container">
        <div className="text-center">
          <p className="font-[600] text-xl text-[#247EFE]">Team</p>
 
          <h2 className="text-[#082247] md:text-[42px] text-[24px] font-semibold lh-2 mt-[10px]">
            Data veterans from <br />
            Fortune 100
          </h2>
        </div>
 
        <div className="mt-[40px] grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 md:gap-[30px]">
          {teamData.map((team, index) => (
            <div key={index} className="team-card flex flex-col bg-white rounded-lg overflow-hidden">
              <div className="team-img aspect-[4/5] w-full overflow-hidden rounded-lg relative">
                <img
                  src={team.img}
                  className="w-full h-full object-contain bg-gray-50 hover:scale-105 transition-transform duration-300"
                  alt={team.name}
                />
              </div>
              <div className="team-content p-4">
                <div className="team-header flex justify-between items-center">
                  <h3 className="text-lg md:text-xl font-[600] text-[#082247]">
                    {team.name}
                  </h3>
                  <a
                    href={team.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex w-[24px] h-[24px] text-xs justify-center items-center bg-[#247EFE] rounded-full text-white hover:bg-[#1b63ca] transition-colors"
                  >
                    <FaLinkedinIn />
                  </a>
                </div>
 
                <div className="team-designation mt-2 flex justify-start items-center">
                  <div className="line mr-3 w-[20px] h-[2px] bg-[#8390A3]"></div>
                  <p className="text-[#8390A3] text-sm">{team.designation}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
 
export default Team;